import React from 'react';
import SectionHeader from './SectionHeader';
import WhoWeAre from './WhoWeAre';
import './SectionWhoWeAre.css';

class SectionWhoWeAre extends React.Component {
  render() {
    const {sectionHeader, items} = this.props.ourTeamData;
    return (
      <section id='who-we-are'>
        <SectionHeader item={sectionHeader} />
        <WhoWeAre whoWeAreData={items}/>
      </section>
    )
  }
}

SectionWhoWeAre.propTypes = {
  ourTeamData: React.PropTypes.object.isRequired
}

export default SectionWhoWeAre;



// WEBPACK FOOTER //
// ./src/components/SectionWhoWeAre.js